import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {MatCheckboxModule} from "@angular/material";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from '@angular/router';
import {accountState} from "@logbook/landing/account.route";
import {LoginComponent} from "@logbook/landing/login/login.component";
import {PasswordResetFinishComponent} from "@logbook/landing/password-reset/finish/password-reset-finish.component";
import {PasswordResetFinishService} from "@logbook/landing/password-reset/finish/password-reset-finish.service";
import {PasswordResetInitComponent} from "@logbook/landing/password-reset/init/password-reset-init.component";
import {PasswordResetInitService} from "@logbook/landing/password-reset/init/password-reset-init.service";
import {SignUpConfirmComponent} from "@logbook/landing/sign-up/confirm/sign-up-confirm.component";
import {SignUpComponent} from "@logbook/landing/sign-up/sign-up.component";
import {SignUp} from "@logbook/landing/sign-up/sign-up.service";
import {LogbookSharedModule} from "@logbook/shared";

@NgModule({
    imports: [
        LogbookSharedModule,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        RouterModule.forChild(accountState)
    ],
    declarations: [
        SignUpComponent,
        SignUpConfirmComponent,
        PasswordResetInitComponent,
        PasswordResetFinishComponent,
        LoginComponent
    ],
    providers: [
        SignUp,
        PasswordResetInitService,
        PasswordResetFinishService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LogbookAccountModule {
}
